import { render } from "./boutonZone.vue?vue&type=template&id=242da538&scoped=true"
import script from "./boutonZone.vue?vue&type=script&lang=js"
export * from "./boutonZone.vue?vue&type=script&lang=js"

import "./boutonZone.vue?vue&type=style&index=0&id=242da538&lang=scss&scoped=true"

import exportComponent from "/usr/src/test-oho-sales/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-242da538"]])

export default __exports__